import { useApp } from '../app/app_provider';


export default function useRouter() {
  const app    = useApp();
  const router = app?.views?.main?.router;
  return router;
}
